import { useState } from "react";

import { cn } from "@/shared/lib/css";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: React.ReactNode;
  skeleton?: boolean;
}

export function Image({
  src,
  alt,
  className,
  fallback,
  skeleton = true,
  ...props
}: ImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return fallback ?? <div className={cn("bg-secondary size-full", className)} />;
  }

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={cn(
          "w-full h-full transition-opacity duration-300",
          isLoading && "opacity-0",
          className,
        )}
        loading="lazy"
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false);
          setHasError(true);
        }}
        {...props}
      />
    </>
  );
}
